const CONSTANT = {
    BLANK_LINK: "#!",
    apiUrl: process.env.REACT_APP_API_URL, // "https://localhost:3000/api",
    validEmailRegex: RegExp(/^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/i)
};

export default CONSTANT;
